import React from "react";
import RastreamentoPage from "./RastreamentoPage";
import { useSelector } from "react-redux";
import { getCenter } from "../../selectors/rastreamento.selectors";

function RastreamentoPageConnected() {
  const position = useSelector(getCenter);

  return <RastreamentoPage position={position} />;
}

export default RastreamentoPageConnected;
